import axios from 'axios';

const PHARMACY_API_URL = process.env.PHARMACY_API_URL;

export interface IMedicine {
  id: number;
  denominacaoGenerica: string;
  formaFarmaceutica: string;
  componenteOriginal: string;
  componenteAgrupado: string;
  localDeRetirada: string;
  disponibilidade: string;
  indicacaoClinicaPcdt: string;
  responsabilidade: string;
}

export interface IMedicinesMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface IMedicinesResponse {
  data: IMedicine[];
  meta: IMedicinesMeta;
}

export interface IMedicinesParams {
  search?: string;
  page?: number;
  limit?: number;
  disponibilidade?: string[];
  formaFarmaceutica?: string[];
  componenteAgrupado?: string[];
  responsabilidade?: string[];
}

export interface IMedicinesFilterOptions {
  disponibilidade: string[];
  formaFarmaceutica: string[];
  componenteAgrupado: string[];
  responsabilidade: string[];
}

interface IDirectusResponse {
  data: IMedicine[];
  meta?: { filter_count?: number };
}

export async function getMedicines(
  params: IMedicinesParams
): Promise<IMedicinesResponse> {
  const page = Math.max(1, params.page ?? 1);
  const limit = Math.max(1, params.limit ?? 12);

  const queryParams: Record<string, string | number | string[]> = {
    page,
    limit,
    meta: 'filter_count',
  };

  if (params.search) {
    queryParams.globalSearch = params.search;
  }

  if (params.disponibilidade?.length) {
    queryParams['filter[disponibilidade][_in]'] = params.disponibilidade;
  }
  if (params.formaFarmaceutica?.length) {
    queryParams['filter[formaFarmaceutica][_in]'] = params.formaFarmaceutica;
  }
  if (params.componenteAgrupado?.length) {
    queryParams['filter[componenteAgrupado][_in]'] = params.componenteAgrupado;
  }
  if (params.responsabilidade?.length) {
    queryParams['filter[responsabilidade][_in]'] = params.responsabilidade;
  }

  const response = await axios.get<IDirectusResponse>(
    `${PHARMACY_API_URL}/v1/rememe`,
    {
      params: queryParams,
      paramsSerializer: (p) => {
        const usp = new URLSearchParams();
        Object.entries(p).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => usp.append(key, String(v)));
          } else if (value !== undefined && value !== null) {
            usp.append(key, String(value));
          }
        });
        return usp.toString();
      },
    }
  );

  const total = response.data.meta?.filter_count ?? 0;
  const totalPages = total === 0 ? 0 : Math.ceil(total / limit);

  return {
    data: response.data.data ?? [],
    meta: {
      total,
      page,
      limit,
      totalPages,
      hasNextPage: page < totalPages,
      hasPreviousPage: page > 1,
    },
  };
}

export async function getMedicinesFilters(): Promise<IMedicinesFilterOptions> {
  return {
    // ES-868: filtro de disponibilidade desativado — manter para reativação futura
    // disponibilidade: ['Com Disponibilidade', 'Sem Disponibilidade'],
    disponibilidade: [],
    formaFarmaceutica: [],
    componenteAgrupado: [],
    responsabilidade: ['Estado', 'Município', 'União'],
  };
}
